import { ParameterBag } from './parameter-bag';
import { ParametersType } from '../../interfaces/components/dependency-injection/parameter-bag.interface';

export class FrozenParameterBag extends ParameterBag {
  public override add (parameters: ParametersType): void {
    throw new Error('Impossible to call add() on a frozen ParameterBag.');
  }

  public override clear (): void {
    throw new Error(`Impossible to call clear() on a frozen ParameterBag.`);
  }

  public override set (name: string | symbol, value: unknown): void {
    throw new Error('Impossible to call set() on a frozen ParameterBag.');
  }

  public override remove (name: string | symbol): void {
    throw new Error('Impossible to call remove() on a frozen ParameterBag.');
  }
}
